import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { getTotalConcurrents } from '../features/concurrents/concurrentsSlice';
import { selectUserInfo } from '../features/users/userInfoSlice';
import { selectTotal } from '../features/websites/websitesSlice';
import { classNames } from '../utils';

/**
 * TAB NAVIGATION COMPONENT
 * @param {{ tabs: {title: string, href: string, disabled: boolean}[] }} props 
 * @returns {JSX.Element}
 */
const TabNavigation = ({ tabs }) => {
  const { location, push } = useHistory()

  /**
   * @type {boolean}
   */
  const loadingWebsite = useSelector(state => state.websites.loading)

  /**
   * @type {boolean}
   */
  const loadingConcurrent = useSelector(state => state.concurrents.loading)
  const totalWebsites = useSelector(selectTotal)
  const totalConcurrents = useSelector(getTotalConcurrents)
  const userContext = useSelector(selectUserInfo);


  const _displayBadge = useCallback((path, href) => {
    switch (href) {
      case '/websites':
        return <div className={classNames("badge badge-sm", href === path ? 'bg-general-teal border-general-teal' : '')}>{totalWebsites}</div>
      case '/websites/concurrents':
        return <div className={classNames("badge badge-sm", href === path ? 'bg-general-teal border-general-teal' : '')}>{totalConcurrents}</div>
      default:
        break;
    }
  }, [totalConcurrents, totalWebsites])

  const hrefMap = {
    '/websites/connexions': 'goTostep3',
    '/websites/concurrents': 'goTostep2-3',
    '/account/users': 'goTostep6',
    '/websites/quiz': 'goTostep3-quiz'
  }

  return (
    <nav className="flex -mb-px border border-gray-200 bg-gray-200 rounded-full gap-2 p-1 mx-2">
      {tabs.map((item, index) => {
        if (item.href === '/websites' && !userContext?.user?.admin) return
        if (item.href.startsWith('/account/') && !userContext?.user?.admin) return

        return (
          <button
            id={hrefMap[item.href] || ''}
            disabled={item?.disabled || loadingWebsite || loadingConcurrent}
            onClick={() => {
              if (location.pathname.startsWith('/account/users/edit/')) push('/account/users')
              else push(item.href)
            }}
            className={classNames('rounded-full group inline-flex items-center py-1.5 px-3 border-2 space-x-1.5 hover:border-gray-300 font-medium text-sm leading-5 disabled:bg-gray-200 disabled:cursor-not-allowed transition-colors', location.pathname === item.href ? 'bg-white text-general-teal'
              : 'text-gray-500 focus:outline-none focus:text-gray-700 focus:border-gray-300')}
            key={index}
          >
            {item?.icon}
            <span title={item.title}>{item.title || 'Tab ' + index} {_displayBadge(location.pathname, item.href)}</span>
          </button>
        )
      })}
    </nav>
  );
};
export default TabNavigation;
